import casePrepPreview from "../../image/education/medical-sensei/case-prep.png";
import simulationPreview from "../../image/education/medical-sensei/simulation.png";
import instructorPreview from "../../image/education/medical-sensei/instructor.png";
import debatePreview from "../../image/education/medical-sensei/debate.png";
import reflectionPreview from "../../image/education/medical-sensei/reflection.png";

/** Maps Medical Sensei module preview keys to bundled assets. */
export const educationModulePreviewAssets: Record<string, string> = {
    "medical-sensei-case-prep": casePrepPreview,
    "medical-sensei-simulation": simulationPreview,
    "medical-sensei-instructor": instructorPreview,
    "medical-sensei-debate": debatePreview,
    "medical-sensei-reflection": reflectionPreview,
};

export function getEducationModulePreviewSrc(
    assetKey: string | undefined
): string | undefined {
    if (!assetKey) return undefined;
    return educationModulePreviewAssets[assetKey];
}
